import React, {useEffect, useRef, useState} from 'react';
import {Dialog} from 'primereact/dialog';
import PropTypes from 'prop-types';
import {ContainerForm} from '../../../components/Containers/ContainerForm';
import {ContainerGroupForm} from '../../../components/Containers/ContainerGroupForm';
import {guardarAsociado, selectAsociados} from '../../../api/asociado.service';
import {Toast} from 'primereact/toast';
import {useForm} from "react-hook-form";
import {UseLoader} from "../../../hooks/useLoader";
import { confirmDialog } from 'primereact/confirmdialog';



export const ModalNuevoAsociado = ({show, hide}) => {

    const [handleLoader] = UseLoader();
    const toast = useRef(null);
    const [afp, setAfp] = useState([]);
    const [eps, setEps] = useState([]);
    const [tipoCuenta, setTipoCuenta] = useState([]);
    const [tipoDoc, setTipoDoc] = useState([]);
    const [banco, setBanco] = useState([]);
    const {register, handleSubmit, formState: {errors}} = useForm();


    const getSelect = async () => {
        try {
            const response = await selectAsociados();
            return await response.data;
        } catch (e) {
            console.log(e)
        }
    }

    const onSubmit = async payload => {
        try {
            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () =>  {
                    handleLoader(true)
                    const response = await guardarAsociado(payload);
                    const data = await response.data;
                    handleLoader(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity:'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide()
                }
            });

        } catch (e) {
            handleLoader(false)
            console.log(e)
        }
    }

    useEffect(() => {
        if (show) {
            getSelect().then(r => {
                if (r.estado === 200) {
                    const data = r.data;
                    setAfp(data.afp);
                    setEps(data.eps);
                    setTipoCuenta(data.tipoCuenta);
                    setTipoDoc(data.tipoDoc);
                    setBanco(data.banco)
                } else {
                    toast.current?.show({severity:'warn', summary: 'Alerta', detail: r.mensaje, life: 3000});
                    return;
                }
            });
        }
        return () => {
            setAfp([]);
            setEps([]);
            setTipoCuenta([]);
            setTipoDoc([]);
            setBanco([])
        };
    }, [show]);

    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Crear nuevo afiliado" visible={show} style={{width: '90vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <h6 className="title-modal">
                                Información principal
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="nombre"
                                    >
                                        Primer nombre *
                                    </label>
                                    <input
                                        {...register("nombre", {required: true, maxLength: 30 })}
                                        id="nombre"
                                        type="text"
                                        className="form-input-small"
                                    />
                                    {errors.nombre?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.nombre?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 30 caracteres</span>}
                                    {/*{errors.nombre?.type === 'pattern' && <span className="text-red-600 font-bold text-xs">Formato incorrecto</span>}*/}
                                </ContainerGroupForm>


                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="segundoNombre"
                                    >
                                        Segundo nombre
                                    </label>
                                    <input
                                        type="text"
                                        {...register("segundoNombre", {maxLength: 30 })}
                                        className="form-input-small"
                                        id="segundoNombre"
                                    />

                                    {errors.segundoNombre?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 30 caracteres</span>}

                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="primerApellido"
                                    >
                                        Primer apellido *
                                    </label>
                                    <input
                                        {...register("primerApellido", {required: true,  maxLength: 30 })}
                                        type="text"
                                        className="form-input-small"
                                        id="primerApellido"
                                    />
                                    {errors.primerApellido?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.primerApellido?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 30 caracteres</span>}

                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="segundoApellido"
                                    >
                                        Segundo apellido
                                    </label>
                                    <input
                                        type="text"
                                        {...register("segundoApellido", {  maxLength: 30 })}
                                        className="form-input-small"
                                        id="segundoApellido"/>

                                    {errors.segundoApellido?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 30 caracteres</span>}

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="tipoDoc"
                                    >
                                        Tipo documento
                                    </label>
                                    <select
                                        className="form-input-small"
                                        {...register("tipoDoc", {required: true })}
                                        id="tipoDoc">
                                        <option value="">seleccione</option>
                                        {tipoDoc.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>

                                    {errors.tipoDoc?.type === 'pattern' && <span className="text-red-600 font-bold text-xs">Formato incorrecto</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="NumDoc"
                                    >
                                        Numero de documento
                                    </label>
                                    <input
                                        type="text"
                                        {...register("numDoc", {required: true, maxLength: 20 })}
                                        className="form-input-small"
                                        id="NumDoc"/>

                                    {errors.numDoc?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 15 caracteres</span>}
                                    {errors.numDoc?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="email"
                                    >
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        {...register("email", {required: true, maxLength: 150 })}
                                        className="form-input-small"
                                        id="email"/>
                                    {errors.email?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 150 caracteres</span>}
                                    {errors.email?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="afp"
                                    >
                                        Afp
                                    </label>
                                    <select
                                        {...register("afp", {required: true })}
                                        className="form-input-small"
                                        id="afp">
                                        <option value="">seleccione</option>
                                        {afp.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>
                                    {errors.afp?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="eps"
                                    >
                                        Eps
                                    </label>
                                    <select
                                        {...register("eps", {required: true })}
                                        className="form-input-small"
                                        id="eps">
                                        <option value="">seleccione</option>
                                        {eps.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>
                                    {errors.eps?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="eps"
                                    >
                                        Pensionado
                                    </label>
                                    <select
                                        {...register("pensionado", {required: true })}
                                        className="form-input-small"
                                        id="pensionado">
                                        <option value="">seleccione</option>
                                        <option value="S">Si</option>
                                        <option value="N">No</option>
                                    </select>
                                    {errors.pensionado?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="banco"
                                    >
                                        Banco
                                    </label>
                                    <select
                                        {...register("banco", {required: true })}
                                        className="form-input-small"
                                        id="banco">
                                        <option value="">seleccione</option>
                                        {banco.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>
                                    {errors.banco?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="tipoCuenta"
                                    >
                                        Tipo de cuenta
                                    </label>
                                    <select
                                        {...register("tipoCuenta", {required: true })}
                                        className="form-input-small"
                                        id="tipoCuenta">
                                        <option value="">seleccione</option>
                                        {tipoCuenta.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>
                                    {errors.tipoCuenta?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="NumCuen"
                                    >
                                        Numero de cuenta
                                    </label>
                                    <input
                                        type="text"
                                        {...register("numCuen", {required: true, maxLength: 30 })}
                                        className="form-input-small"
                                        id="NumCuen"/>
                                    {errors.numCuen?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 30 caracteres</span>}
                                    {errors.numCuen?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="estado"
                                    >
                                        Estado *
                                    </label>
                                    <select
                                        {...register("estado", {required: true })}
                                        className="form-input-small"
                                        id="estado">
                                        <option value="">seleccione</option>
                                        <option value="A">Activo</option>
                                        <option value="I">Inactivo</option>
                                    </select>
                                    {errors.estado?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>
                            </div>

                            <hr className="mt-6 border-b-1 border-blueGray-300"/>

                            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
                                Informacion para usuario de ingreso
                            </h6>

                            <div className="row">
                                <ContainerGroupForm>
                                    <label
                                        className="label-form"
                                        htmlFor="usuario"
                                    >
                                        Usuario
                                    </label>
                                    <input
                                        type="text"
                                        {...register("usuario", {required: true, pattern: /^[A-Za-z0-9_]+$/i, maxLength: 100  })}
                                        className="form-input-small"
                                        id="usuario"/>
                                    {errors.usuario?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.usuario?.type === 'pattern' && <span className="text-red-600 font-bold text-xs">Solo se aceptan números y letras</span>}
                                    {errors.usuario?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 100 caracteres</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm>
                                    <label
                                        className="label-form"
                                        htmlFor="usuario"
                                    >
                                        Contraseña
                                    </label>
                                    <input
                                        type="password"
                                        {...register("password", {required: true, maxLength: 16, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*{}-])(?=.{8,30})/i })}
                                        className="form-input-small"
                                        id="usuario"/>
                                    {errors.password?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.password?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 16 caracteres</span>}
                                    {errors.password?.type === 'pattern' && <span className="text-red-600 font-bold text-xs">Formato incorrecto (debe tener al menos una mayuscula, número y un caracter especial)</span>}
                                </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>

                        </form>
                    </ContainerForm>
                </div>

            </Dialog>
        </>

    );
};
ModalNuevoAsociado.prototype = {
    show: PropTypes.bool,
    hide: PropTypes.func
}

ModalNuevoAsociado.defaultProps = {
    show: false,
};
